const fn = {
    init: () => {
        const select = document.getElementById('faq-category-filter')
        const clear = document.getElementById('faq-clear-filter')
        if (select) {
            select.addEventListener('change', fn.handleFilter)
        }
        if (clear) {
            clear.addEventListener('click', fn.handleClear)
        }
    },

    handleFilter: (e) => {
        const selectedId = e.target.value
        const categories = document.querySelectorAll('.faq-category')
        const clear = document.getElementById('faq-clear-filter')

        if (clear) {
            clear.classList.toggle('hidden', !selectedId)
        }

        categories.forEach((category) => {
            const categoryId = category.dataset.categoryId

            if (!selectedId || categoryId === selectedId) {
                category.classList.remove('hidden')
            } else {
                category.classList.add('hidden')
            }

            const titles = category.querySelectorAll('.accordion-item .title')
            titles.forEach((title) => {
                if (!selectedId || categoryId === selectedId) {
                    if (!title.classList.contains('closed')) {
                        title.classList.add('closed')
                    }
                }
            })

            const contents = category.querySelectorAll('.accordion-content')
            contents.forEach((content) => {
                if (!selectedId || categoryId === selectedId) {
                    if (!content.classList.contains('hidden')) {
                        content.classList.add('hidden')
                    }
                }
            })
        })
    },

    handleClear: (e) => {
        e.preventDefault()
        const select = document.getElementById('faq-category-filter')
        if (select) {
            select.value = ''
            select.dispatchEvent(new Event('change'))
        }
    }
}

export default {
    can: () => document.querySelector('#faq-category-filter'),
    run: fn.init,
}
